import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import chunk from 'lodash/chunk';
import cloneDeep from 'lodash/cloneDeep';
import extend from 'lodash/extend';
import withRouter from 'react-router/withRouter';
import formatPostObject from '../../../../utils/format_post_object';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import Ad from '../../../components/ad/ad';
import NotFound from '../../../components/not_found_component/not_found_component';
import LoadingSpinner from '../../../components/loading_spinner/loading_spinner';
import Slug from '../../../components/slug/slug';
import Card from '../../../components/card/card';
import MagazineArchive from '../../../components/magazine_archive/magazine_archive';
import loadData from './tag_page_state_manager';

// eslint-disable-next-line react/prefer-stateless-function
class MagazineTag extends Component {
  static loadData(store, override) {
    return loadData(store, override);
  }

  renderTagRows(posts, key, title = null) {
    const elements = [];
    const tagPosts = cloneDeep(posts);
    const totalPosts = get(tagPosts, 'length') ? get(tagPosts, 'length') : 0;

    if (totalPosts > 1) {
      if (title) {
        elements.push(
          <Slug
            slugName={title}
            className="tag-page-section"
            key={`${key}-slug`}
          />
        );
      }

      let firstRow;
      if (totalPosts <= 3) {
        firstRow = tagPosts.splice(0, totalPosts);
      } else {
        firstRow = tagPosts.splice(0, 2);
      }

      const chunks = chunk(tagPosts, 3);
      const totalChuncks = get(chunks, 'length');
      const lastChunk = chunks[totalChuncks - 1];

      if (get(lastChunk, 'length') === 1) {
        chunks[totalChuncks - 1].push(lastChunk[0]);
        chunks.pop();
      }

      const seperatedPosts = [firstRow, ...chunks];

      seperatedPosts.map((rowPosts, index) =>
        elements.push(
          <div className="row" key={`${key}-row-${index + 1}`}>
            {rowPosts.map(post => (
              <Card
                config={this.props.config}
                key={post.id}
                metadata={formatPostObject({
                  post,
                  imgSize: imageSizesLookup[get(rowPosts, 'length')],
                  allowTextOnly: true
                })}
                totalCards={get(rowPosts, 'length')}
              />
            ))}
          </div>
        )
      );
    }

    return elements;
  }

  render() {
    if (this.props.tagPage.error || this.props.magazineIssuePosts.error) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.tagPage.isLoading) {
      return (
        <section className="tag-page">
          <article className="tag-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { tagPage, magazineIssuePosts, config, match } = this.props;
    const adData = get(tagPage, 'ads');
    const combinedAdModel = extend(
      {},
      { baseConfig: get(adData, 'config.baseConfig') },
      { definitions: get(adData, 'config.definitions') },
      { model: get(adData, 'model') }
    );
    const { coverStory, next, departments, issue, magazineArchive } = get(
      magazineIssuePosts,
      'data',
      {}
    );

    const features = get(magazineIssuePosts, 'data.features', []);
    const hasFeatures = get(features, 'length') > 1;
    const hasTopRow =
      get(issue, 'title') && get(issue, 'image') && !isEmpty(coverStory);
    const issueNumber = match.params.tag.replace('issue-', '');

    return (
      <section className="tag-page tag-page--magazine">
        <Ad {...combinedAdModel} name="oop" slug={false} oop={true} />

        <section className="page-title">
          <h1 className="page-description">{get(issue, 'description', '')}</h1>
          <Slug
            slugName={get(issue, 'title', `Fast Company Issue ${issueNumber}`)}
            className="tag-page"
          />
        </section>

        {hasTopRow ? (
          <div className="row row--magazine row__top">
            <div className="row__aside">
              <Card
                config={config}
                type="magazine"
                metadata={issue}
                fullWidth={true}
                hasTitle={false}
                fullIssue={false}
              />
            </div>
            <div className="row__main">
              <Card
                config={config}
                type="featured"
                metadata={formatPostObject({
                  post: coverStory,
                  imgSize: imageSizesLookup[1],
                  allowTextOnly: true
                })}
              />
            </div>
          </div>
        ) : null}

        {hasFeatures || (!hasTopRow && hasFeatures)
          ? [
              hasTopRow ? (
                <Slug
                  slugName="Features"
                  className="tag-page-section"
                  key="features-slug"
                />
              ) : null,
              <div className="row" key="features-3-row">
                {features.slice(0, 2).map(post => (
                  <Card
                    config={config}
                    key={post.id}
                    metadata={formatPostObject({
                      post,
                      imgSize: imageSizesLookup[3],
                      allowTextOnly: true
                    })}
                    index={3}
                    totalCards={3}
                  />
                ))}
                <div className="card card--default card--subscribe">
                  <a href="https://magazine.fastcompany.com/loc/FST/siteads">
                    <img
                      className="subscribe--square"
                      src="https://images.fastcompany.net/image/upload/v1589388551/fcweb/Subscribe_Ad_360x313_qbfsha.jpg"
                      alt="The future of business starts here. Subscribe now."
                    />
                  </a>
                </div>
              </div>,
              this.renderTagRows(features.slice(2), 'features')
            ]
          : null}

        {this.renderTagRows(next, 'next', 'Next')}

        <div className="tag-page__ff-ad-container">
          <Ad
            {...combinedAdModel}
            name="flexiblebillboard_2"
            noLazyLoad={true}
          />
          <Ad {...combinedAdModel} name="mobilerectangle_1" noLazyLoad={true} />
        </div>

        {this.renderTagRows(departments, 'departments', 'Departments')}

        <MagazineArchive config={config} magazines={magazineArchive} />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    featuredSponsoredCard: get(state, 'featuredSponsoredCard.data') || {},
    tagFeaturedFeed: {
      featured: get(state, 'tagFeaturedFeed.featured') || [],
      top: get(state, 'tagFeaturedFeed.top') || [],
      tag: get(state, 'tagFeaturedFeed.tag') || {},
      source: get(state, 'tagFeaturedFeed.source') || '',
      error: get(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: get(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: get(state, 'tagPage') || { error: true },
    tagScrollingModule: get(state, 'tagScrollingModule.data') || {},
    tagPromoBanner: get(state, 'tagPromoBanner.data') || {},
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    },
    magazineArchive: get(state, 'magazineArchive') || {},
    magazineIssuePosts: get(state, 'magazineIssuePosts') || { error: true }
  };
}

MagazineTag.propTypes = {
  config: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired,
  tagPage: PropTypes.shape({
    ads: PropTypes.object,
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  tagFeaturedFeed: PropTypes.shape({
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    tag: PropTypes.object,
    source: PropTypes.string,
    error: PropTypes.bool
  }).isRequired,
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool,
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number
  }).isRequired,
  magazineArchive: PropTypes.shape({}).isRequired,
  magazineIssuePosts: PropTypes.shape({
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(MagazineTag));
